import React, { useState, useEffect, useCallback } from 'react';
import { tasksAPI, Task } from '../api/api';
import { useAuth } from '../context/AuthContext';
import TaskCard from './TaskCard';
import CreateTaskModal from './CreateTaskModal';
import Navbar from './Navbar';
import './TaskList.css';

const TaskList: React.FC = () => {
  const { user, isImpersonating } = useAuth();
  const [tasks, setTasks] = useState<Task[]>([]);
  const [loading, setLoading] = useState(true);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [filter, setFilter] = useState<'all' | 'open' | 'completed'>('all');
  const [searchQuery, setSearchQuery] = useState('');

  const loadTasks = useCallback(async () => {
    try {
      setLoading(true);
      const data = await tasksAPI.getAll(searchQuery || undefined);
      setTasks(data);
    } catch (error) {
      console.error('Ошибка при загрузке задач:', error);
    } finally {
      setLoading(false);
    }
  }, [searchQuery, user?.id, isImpersonating]);

  useEffect(() => {
    loadTasks();
  }, [loadTasks]);

  const handleTaskCreated = () => {
    loadTasks();
    setShowCreateModal(false);
  };

  const handleTaskUpdated = () => {
    loadTasks();
  };

  const filteredTasks = tasks.filter(task => {
    if (filter === 'all') return true;
    return task.status === filter;
  });

  if (loading) {
    return <div className="loading">Загрузка...</div>;
  }

  return (
    <>
      <Navbar />
      <div className="task-list-container">
        <div className="task-list-header">
          <h1>Задачи</h1>
          <div className="header-actions">
            <input
              type="text"
              placeholder="Поиск по задачам..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="search-input"
            />
            <select
              value={filter}
              onChange={(e) => setFilter(e.target.value as any)}
              className="filter-select"
            >
              <option value="all">Все</option>
              <option value="open">Открытые</option>
              <option value="completed">Завершенные</option>
            </select>
            <button
              onClick={() => setShowCreateModal(true)}
              className="create-btn"
            >
              + Создать задачу
            </button>
          </div>
        </div>

      <div className="tasks-grid">
        {filteredTasks.length === 0 ? (
          <div className="empty-state">Нет задач</div>
        ) : (
          filteredTasks.map((task) => (
            <TaskCard
              key={task.id}
              task={task}
              onUpdate={handleTaskUpdated}
            />
          ))
        )}
      </div>

      {showCreateModal && (
        <CreateTaskModal
          onClose={() => setShowCreateModal(false)}
          onTaskCreated={handleTaskCreated}
        />
      )}
      </div>
    </>
  );
};

export default TaskList;

